import React, { memo } from 'react';
import { useWindowSize } from '@surveycake/rhooks';
import {
  useSubjectId,
  useEngineInstance
} from '@surveycake/react-logic-engine';
import NestDesktop from './NestDesktop';
import NestMobile from './NestMobile';
import { useNestAnswerConfig } from './hooks';
import { useStyles } from './styles';

function Nest() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { childIds, options } = useNestAnswerConfig(engine, id);
  const { width } = useWindowSize();
  const isDesktop = width >= 720;
  const styles = useStyles([isDesktop]);
  const Component = isDesktop ? NestDesktop : NestMobile;

  return (
    <div className={styles.container} data-subject-id={id}>
      <Component childIds={childIds} options={options} />
    </div>
  );
}

export default memo(Nest);
